import { HttpError } from '@web/walter-lib/api'

const verificationCodeKey = 'verification_code'
const twoFaKey = '2fa'

export enum FORBIDDEN_ERROR_CODES {
    API_KEY = 1003,
    ACL = 20093,
    FREEZE = 602,
}

// eslint-disable-next-line complexity
export const processPermissionError = (err: unknown) => {
    let showVerificationCode = false
    let showTwoFa = false
    let isPermissionError = false
    let isForbiddenError = false
    let isPayoutFrozen = false

    if (err instanceof HttpError && err?.response?.status === 400) {
        const { code } = err.response.data.error || {}
        if (code === FORBIDDEN_ERROR_CODES.FREEZE) {
            isPayoutFrozen = true
        }
    }

    if (err instanceof HttpError && err?.response?.status === 403 && !err?.response?.data?.error?.description) {
        const { code } = err.response.data.error || {}
        if (code === FORBIDDEN_ERROR_CODES.API_KEY || code === FORBIDDEN_ERROR_CODES.ACL) {
            isForbiddenError = true
        }
    }

    if (err instanceof HttpError && err?.response?.status === 403 && err?.response?.data?.error?.description) {
        const { description, code } = err.response.data.error || {}
        isPermissionError = true

        if (code === FORBIDDEN_ERROR_CODES.API_KEY || code === FORBIDDEN_ERROR_CODES.ACL) {
            isForbiddenError = true
        }

        let parsedDescription: string[] = []
        try {
            parsedDescription = JSON.parse(description)
        } catch (e) {
            //
        }

        if (parsedDescription.includes(verificationCodeKey)) {
            showVerificationCode = true
        }
        if (parsedDescription.includes(twoFaKey)) {
            showTwoFa = true
        }
    }

    return { showVerificationCode, showTwoFa, isPermissionError, isForbiddenError, isPayoutFrozen }
}
